import { render, staticRenderFns } from "./GatFieldSpacer.vue?vue&type=template&id=29ab2a3f&scoped=true&"
import script from "./GatFieldSpacer.vue?vue&type=script&lang=js&"
export * from "./GatFieldSpacer.vue?vue&type=script&lang=js&"
import style0 from "./GatFieldSpacer.vue?vue&type=style&index=0&id=29ab2a3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab2a3f",
  null
  
)

export default component.exports